import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "gfu-balloon__wrapper",
  "data-qa": "dropdown-group"
}
const _hoisted_2 = {
  key: 1,
  "data-qa": "dropdown-group"
}
const _hoisted_3 = {
  ref: "balloon-trigger",
  "data-qa": "dropdown-group:CircleMenu"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_toggle_trigger = _resolveComponent("toggle-trigger")
  const _component_toggle_content = _resolveComponent("toggle-content")
  const _component_toggle_container = _resolveComponent("toggle-container")

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.actionsList(_ctx.$slots.default).length === 1)
      ? (_openBlock(), _createBlock(_component_tooltip, {
          key: 0,
          ref: "tooltip",
          class: "_flex",
          text: $options.tooltipText,
          "is-link-behavior-preserved": $props.isLinkBehaviorPreserved,
          "data-qa": `action-button:${$options.tooltipQa}`
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["text", "is-link-behavior-preserved", "data-qa"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_toggle_container, null, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, [
                _createVNode(_component_toggle_trigger, {
                  tag: "a",
                  href: "",
                  class: "gfu-btn--toggler gfu-btn gfu-btn--circle",
                  "inactive-class": "gfu-btn--light-alt",
                  "active-class": "gfu-btn--primary",
                  "collapse-on-scroll": $props.collapseOnScroll && $options.actionsList(_ctx.$slots.default).length > 1,
                  "before-active": $props.beforeOpen,
                  onClick: $options.onTriggerClick,
                  "data-qa": "dropdown-group:CircleMenu"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_icon, { name: "ellipsis-v" })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["collapse-on-scroll", "before-active", "onClick"])
              ], 512 /* NEED_PATCH */),
              _createVNode(_component_toggle_content, {
                ref: "balloon-content",
                tag: "div",
                tabindex: "0",
                class: _normalizeClass(["gfu-balloon gfu-balloon--fixed gfu-balloon--center gfu-balloon--up gfu-balloon--no-header is-hidden", $options.resolveBallonClass()]),
                "active-class": "is-open",
                onActiveChange: $options.onActionsBalloonActiveChange,
                "data-qa": "dropdown-group:Content"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "gfu-balloon__content",
                    onClick: _cache[0] || (_cache[0] = (...args) => ($options.onContentClick && $options.onContentClick(...args)))
                  }, [
                    _renderSlot(_ctx.$slots, "default")
                  ])
                ]),
                _: 3 /* FORWARDED */
              }, 8 /* PROPS */, ["class", "onActiveChange"])
            ]),
            _: 3 /* FORWARDED */
          })
        ]))
  ], 512 /* NEED_PATCH */)), [
    [_vShow, $props.forceShow || $options.actionsList(_ctx.$slots.default).length]
  ])
}